import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

export const resolveTargetId = (
  target?: string,
  cols?: Record<string, any>,
) => {
  if (!target || !cols) return undefined;

  const targetEntry = Object.entries(cols).find(
    ([, col]: [string, any]) => col?.id === target,
  );

  return targetEntry?.[0];
};

export const resolveTargetIdInSection = (
  target?: string,
  rows?: Array<{ cols?: Record<string, any> }>,
) => {
  if (!target || !rows) return undefined;

  for (const row of rows) {
    const match = resolveTargetId(target, row.cols);
    if (match) return match;
  }

  return undefined;
};

export const resolveCopyValTarget = (
  feature?: string,
  target?: string,
  cols?: Record<string, any>,
) => {
  if (feature !== "copyVal") return undefined;
  return resolveTargetId(target, cols);
};

export const useCopyVal = () => {
  const { setValue } = useFormContext();

  const applyCopyVal = useCallback(
    ({
      feature,
      targetField,
      value,
    }: {
      feature?: string;
      targetField?: string;
      value: any;
    }) => {
      if (feature !== "copyVal" || !targetField) return;
      setValue(targetField, value);
    },
    [setValue],
  );

  return {
    applyCopyVal,
  };
};
